import styled from 'styled-components';

import { CELL_SEPARATOR_COLOR, CELL_VALUE_COLOR, DIVIDER_COLOR } from '../styles';

const BAR_WIDTH = '0.25rem';
const BAR_SLOT_WIDTH = '1.5rem';

interface CellProps {
	separator: boolean;
}

export const HeaderBar = styled.span`
	display: block;
	width: ${BAR_WIDTH};
	height: 1rem;
	margin: 0.5rem 0 0.5rem 0.625rem;
	background: ${DIVIDER_COLOR};
	border-radius: 0.125rem;
`;

export const RowTitle = styled.h4`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.25rem;
	font-weight: 600;
	line-height: 2rem;
	letter-spacing: -0.00625rem;
`;

export const StatusIcon = styled.span`
	display: inline-flex;
	width: 1.5rem;
	height: 1.5rem;

	svg {
		width: 1.5rem;
		height: 1.5rem;
	}
`;

export const RowBarSlot = styled.div`
	flex: 0 0 ${BAR_SLOT_WIDTH};
	width: ${BAR_SLOT_WIDTH};
	margin-right: 1rem;
	align-self: stretch;
`;

export const RowBar = styled.span`
	display: block;
	width: ${BAR_WIDTH};
	height: calc(100% - 1rem);
	margin: 0.5rem 0 0 0.625rem;
	background: ${DIVIDER_COLOR};
	border-radius: 0.125rem;
`;

export const Cell = styled.div<CellProps>`
	flex: 1 0 0;
	min-width: 0;
	padding: 0 0.5rem;
	padding-left: ${({ separator }) => (separator ? '0.5rem' : '0')};
	border-left: ${({ separator }) => (separator ? `1px solid ${CELL_SEPARATOR_COLOR}` : 'none')};
`;

export const CellHeader = styled.span`
	display: flex;
	align-items: center;
	min-height: 1.5rem;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1rem;
`;

export const CellValue = styled.span`
	display: block;
	margin-top: 0.5rem;
	color: ${CELL_VALUE_COLOR};
	font-size: 0.75rem;
	line-height: 1.125rem;
	word-break: break-word;
`;

export const RpnHeader = styled(CellHeader)`
	font-size: 1rem;
	line-height: 1.5rem;
`;

export const RpnValue = styled(CellValue)`
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1rem;
`;
